import { scrollToY } from './scrollToY';
import inView from 'in-view';

const moduleName = 'recharge';

export function recharge() {

    Array.from(document.querySelectorAll('.js-recharge')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const recharge = self;
        const rechargeItems = recharge.querySelectorAll('.js-recharge-item');
        const rechargeEntries = recharge.querySelectorAll('.js-recharge-entry');
        const rechargeSum = recharge.querySelector('.js-recharge-sum');
        const rechargePaymentButtonHolder = recharge.querySelector('.js-recharge-payment-button-holder');
        const rechargePaymentButton = recharge.querySelector('.js-recharge-payment-button');
        const rechargePaymentButtonTooltip = recharge.querySelector('.js-recharge-payment-button-tooltip');
        const rechargeMoreButton = recharge.querySelector('.js-recharge-more-button');
        const rechargePayments = recharge.querySelector('.js-recharge-payments');
        const rechargePaymentRadios = recharge.querySelectorAll('.js-recharge-payment-radio');
        const rechargeFakeSubmitButton = recharge.querySelector('.js-recharge-fake-submit-button');
        const rechargeFakeSubmitTooltip = recharge.querySelector('.js-recharge-fake-submit-tooltip');
        let rechargePaymentButtonTooltipTimer;
        let rechargeFakeSubmitTooltipTimer;

        Array.from(rechargeItems).forEach((rechargeItem) => {
            const rechargeEntry = rechargeItem.querySelector('.js-recharge-entry');

            rechargeEntry.addEventListener('input', () => {
                if (rechargeEntry.value != '') {
                    rechargeItem.classList.add('_active');
                } else {
                    rechargeItem.classList.remove('_active');
                }

                updateSum();
            });
        });

        rechargePaymentButton.addEventListener('mouseenter', () => {
            if (document.body.classList.contains('mobile')) return;

            if (rechargePaymentButton.classList.contains('_disabled')) {
                rechargePaymentButtonTooltip.classList.add('_visible');
            }
        });

        rechargePaymentButton.addEventListener('mouseleave', () => {
            if (document.body.classList.contains('mobile')) return;

            if (rechargePaymentButtonTooltip.classList.contains('_visible')) {
                hideTooltip();
            }
        });

        rechargePaymentButton.addEventListener('click', () => {
            if (rechargePaymentButton.classList.contains('_disabled')) {
                if (!document.body.classList.contains('mobile')) return;

                rechargePaymentButtonTooltip.classList.add('_visible');
                rechargePaymentButtonTooltipTimer = setTimeout(hideTooltip, 5000);
            } else {
                showPayments();
            }
        });

        document.addEventListener('click', (event) => {
            if (rechargePaymentButtonTooltip.classList.contains('_visible') && !event.target.closest('.js-recharge-payment-button')) {
                clearTimeout(rechargePaymentButtonTooltipTimer);
                hideTooltip();
            }
        });

        if (rechargeMoreButton) {
            rechargeMoreButton.addEventListener('click', () => {
                const rechargeMoreButtonHolder = recharge.querySelector('.js-recharge-more-button-holder');
                const rechargeHiddenItems = recharge.querySelectorAll('.js-recharge-item._hidden');

                rechargeMoreButtonHolder.classList.add('_hidden');
                Array.from(rechargeHiddenItems).forEach((rechargeHiddenItem) => {
                    rechargeHiddenItem.classList.remove('_hidden');
                });
            });
        }

        Array.from(rechargePaymentRadios).forEach((rechargePaymentRadio) => {
            rechargePaymentRadio.addEventListener('change', showSubmitButtonHolder);
        });

        updatePaymentButtonPosition();
        window.addEventListener('scroll', updatePaymentButtonPosition);

        // Fake submit tooltip
        rechargeFakeSubmitButton.addEventListener('mouseenter', () => {
            if (document.body.classList.contains('mobile')) return;
            rechargeFakeSubmitTooltip.classList.add('_visible');
        });

        rechargeFakeSubmitButton.addEventListener('mouseleave', () => {
            if (document.body.classList.contains('mobile')) return;
            rechargeFakeSubmitTooltip.classList.remove('_visible');
        });

        rechargeFakeSubmitButton.addEventListener('click', () => {
            if (!document.body.classList.contains('mobile')) return;
            rechargeFakeSubmitTooltip.classList.add('_visible');
            rechargeFakeSubmitTooltipTimer = setTimeout(() => {
                rechargeFakeSubmitTooltip.classList.remove('_visible');
            }, 5000);
        });

        document.addEventListener('click', (event) => {
            if (rechargeFakeSubmitTooltip.classList.contains('_visible') && !event.target.closest('.js-recharge-fake-submit-button')) {
                clearTimeout(rechargeFakeSubmitTooltipTimer);
                rechargeFakeSubmitTooltip.classList.remove('_visible');
            }
        });



        function updatePaymentButtonPosition() {
            if (rechargePaymentButtonHolder.getBoundingClientRect().top + rechargePaymentButtonHolder.offsetHeight <= window.innerHeight) {
                rechargePaymentButtonHolder.classList.add('_static');
            } else {
                rechargePaymentButtonHolder.classList.remove('_static');
            }
        }

        function updateSum() {
            let rechargeSumValue = 0;

            Array.from(rechargeEntries).forEach((rechargeEntry) => {
                rechargeSumValue += +rechargeEntry.value;
            });

            if (rechargeSumValue) {
                rechargePaymentButton.classList.remove('_disabled');
                rechargePaymentButtonHolder.classList.add('_active');
            } else {
                hidePayments();
            }

            rechargeSum.innerHTML = rechargeSumValue;
        }

        function hideTooltip() {
            rechargePaymentButtonTooltip.classList.remove('_visible');
        }

        function showPayments() {
            rechargePayments.classList.remove('_hidden');
            rechargePaymentButtonHolder.classList.add('_hidden');

            const rechargePaymentsOffsetTop = rechargePayments.getBoundingClientRect().top + (window.scrollY || document.body.scrollTop);

            if (document.body.clientWidth < 568) {
                scrollToY(rechargePaymentsOffsetTop - 65);
            } else if (document.body.clientWidth < 1190) {
                scrollToY(rechargePaymentsOffsetTop - 90);
            } else {
                scrollToY(rechargePaymentsOffsetTop);
            }
        }

        function hidePayments() {
            rechargePaymentButtonHolder.classList.remove('_hidden');
            rechargePaymentButtonHolder.classList.remove('_active');
            rechargePaymentButton.classList.add('_disabled');
            rechargePayments.classList.add('_hidden');
        }

        function showSubmitButtonHolder() {
            const checkedRadio = recharge.querySelector('.js-recharge-payment-radio:checked');
            const checkedRadioId = checkedRadio.id;
            const rechargeSubmitButtonHolders = recharge.querySelectorAll('.js-recharge-submit-button-holder');

            Array.from(rechargeSubmitButtonHolders).forEach((rechargeSubmitButtonHolder) => {
                const rechargeSubmitButton = rechargeSubmitButtonHolder.querySelector('.js-recharge-submit-button');

                if (rechargeSubmitButtonHolder.dataset.for == checkedRadioId) {
                    rechargeSubmitButtonHolder.classList.add('_active');

                    if (rechargeSubmitButton) {
                        rechargeSubmitButton.disabled = false;

                        if (!inView.is(rechargeSubmitButton)) {
                            scrollToY(rechargeSubmitButton.getBoundingClientRect().top + (window.scrollY || document.body.scrollTop) - window.innerHeight + rechargeSubmitButton.offsetHeight + 10);
                        }
                    }
                } else {
                    rechargeSubmitButtonHolder.classList.remove('_active');
                    if (rechargeSubmitButton) rechargeSubmitButton.disabled = true;
                }
            });
        }
    });

}